import React from 'react';
import PropTypes from 'prop-types';

import {
  ValidatedTextInputV2,
  Visible,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import {
  nonEmptyValidator,
  numberOnlyValidator,
  maxNumberValidator,
  minNumberValidator
} from 'src/validators';
import {
  POOLED_PLATE_VOLUME,
  POOLED_PLATE_VOLUME_MIN_VALUE,
  POOLED_PLATE_VOLUME_MAX_VALUE,
  POOLED_PLATE_NAME,
} from 'src/constants/forms';

import messages from '../../messages';

const PooledPlateFields = ({
  formData = {},
  onChangeData,
  showPlatePoolingCustom,
}) => (
  <div className="pooled-plates-fields">
    <Visible when={!!showPlatePoolingCustom}>
      <ValidatedTextInputV2
        data-testid="pooled-plate-name"
        className="pooled-plates-fields_name"
        label={<Message message={messages.pooledPlateName} />}
        validators={[nonEmptyValidator(messages.emptyPooledPlateNameError)]}
        value={formData[POOLED_PLATE_NAME]?.value}
        onChange={
          (value, e, canValidate, isValid) => onChangeData(value, POOLED_PLATE_NAME, isValid)
        }
        showOnlyOneError
        initialValidation={!!formData[POOLED_PLATE_NAME]?.value}
      />
    </Visible>

    <ValidatedTextInputV2
      data-testid="pooled-plate-volume"
      label={<Message message={messages.pooledPlateVolume} />}
      validators={[
        nonEmptyValidator(messages.emptyPooledPlateInputErrorMessage),
        numberOnlyValidator(messages.noNumberErrorMessagePooledPlate),
        maxNumberValidator(POOLED_PLATE_VOLUME_MAX_VALUE, messages.maxNrVolumeErrorMessage),
        minNumberValidator(POOLED_PLATE_VOLUME_MIN_VALUE, messages.minNrVolumeErrorMessage)
      ]}
      value={formData[POOLED_PLATE_VOLUME]?.value}
      onChange={
        (value, e, canValidate, isValid) => onChangeData(value, POOLED_PLATE_VOLUME, isValid)
      }
      showOnlyOneError
      initialValidation={!!formData[POOLED_PLATE_VOLUME]?.value}
    />
  </div>
);

PooledPlateFields.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  showPlatePoolingCustom: PropTypes.bool,
};

export default PooledPlateFields;
